export enum ShipmentMethod {
    Delivery    = 0,
    PickUp      = 1,
    Fedex       = 2
}

export const ShipmentMethodMetadata = {
    '0': {
        display: 'Delivery',
        value: 0
    },
    '1': {
        display: 'Pickup',
        value: 1
    },
    '2': {
        display: 'Fedex',
        value: 2
    }
};
